/*
 * @description: 文件导出消息提示相关
 * @author: qianh
 * @since: 2025-02-10
 */
import { systemMessageConnector } from "@/views/common/data";
import { Notification } from 'element-ui';
import { isPath, dealPath, addRetryDownloadDealer, isRetryDownload, dealRetryDownload } from "@/views/notice/data";
import {uuid} from "@/utils/uuid";
import {exportFile} from "@/api/TranslationProject";

// pageId集合
let sessionDeals = new Map();
const vm = this;

systemMessageConnector.addEventListener("fileDownloadCompleted", (args) => {
  try{
  const jsonObject = JSON.parse(args.msg);
  const pageId=jsonObject.pageId;
  const content =jsonObject.content;
  if (sessionDeals) {
    const keyExists = sessionDeals.has(pageId);
    if(keyExists){
      let callback = sessionDeals.get(pageId);
      if(callback){
        callback();
      }else{
        Notification({
          title: '通知',
          dangerouslyUseHTMLString: true,
          message: `<div class="component__notice--item system-notification-item">${content}</div>`,
          iconClass: 'el-icon-info'
        });
      }
    }
  }
  }catch(e){
    console.error("消息提示失败："+e);
  }
});

systemMessageConnector.addEventListener("fileDownloadFailed", (args) => {
  try{
    const jsonObject = JSON.parse(args.msg);
    const pageId=jsonObject.pageId;
    const content =jsonObject.content;
    if (sessionDeals) {
      const keyExists = sessionDeals.has(pageId);
      if(keyExists){
        let callback = sessionDeals.get(pageId);
        if(callback){
          callback();
        }else{
          Notification({
            title: '通知',
            dangerouslyUseHTMLString: true,
            message: `<div class="component__notice--item system-notification-item">${content}</div>`,
            iconClass: 'el-icon-warning'
          });
        }
      }
    }
  }catch(e){
    console.error("消息提示失败："+e);
  }
});

export function watchDownloadSessionWithCallback(sessionId,callback){
  sessionDeals.set(sessionId,callback);
}

export function watchDownloadSession(sessionId){
  sessionDeals.set(sessionId,null);
}

export function downloadFile(ele){
  if (!ele) return;
  if(ele.attributes.href.value){
      download(ele.attributes.href.value);
  }
}

export function retryDownloadFile(ele) {
    if (!ele) return;
    dealRetryDownload(ele);
}

addRetryDownloadDealer("cat-file", async (downloadInfo) => {
    try {
        const sessionId = uuid();
        watchDownloadSession(sessionId);
        await exportFile({
            id: downloadInfo.fileId,
            type: downloadInfo.fileType,
            pageId: sessionId
        });
        Notification({
            title: '通知',
            message: "已加入导出队列，请关注系统通知。"
        });
    } catch (error) {
        console.error("Retry download failed:", error);
        Notification({
            title: '错误',
            message: '文件下载失败，请稍后重试',
            type: 'error'
        });
    }
});

//窗口监听
window.addEventListener('click', function (ev) {
  const ele = ev.target;
  if(isPath(ele)){
    dealPath(ele);
    return;
  }
if (isRetryDownload(ele)) {
    retryDownloadFile(ele);
}
});


